export default "__VITE_ASSET__CQGsvH55__"